export interface StoredSession {
  token: string;
  expiresAt: string;
}

const STORAGE_KEY = 'better-auth-session';
let cachedSession: StoredSession | null = null;

export const loadSession = (): StoredSession | null => {
  if (cachedSession) {
    return cachedSession;
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as StoredSession;
    cachedSession = parsed;
    return parsed;
  } catch {
    return null;
  }
};

export const storeSession = (session: StoredSession | null) => {
  cachedSession = session;
  try {
    if (session) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // ignore storage errors
  }
};

export const getSessionToken = (): string | null => {
  const session = cachedSession ?? loadSession();
  if (!session) {
    return null;
  }
  if (new Date(session.expiresAt).getTime() < Date.now()) {
    storeSession(null);
    return null;
  }
  return session.token;
};
